var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVyshunewcard1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1476_5205)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.8594 2.84375H2.14062C1.236 2.84375 0.5 3.57975 0.5 4.48438V11.5156C0.5 12.4203 1.236 13.1562 2.14062 13.1562H13.8594C14.764 13.1562 15.5 12.4203 15.5 11.5156V4.48438C15.5 3.57975 14.764 2.84375 13.8594 2.84375ZM2.14062 3.78125H13.8594C14.2471 3.78125 14.5625 4.09669 14.5625 4.48438V5.42188H1.4375V4.48438C1.4375 4.09669 1.75294 3.78125 2.14062 3.78125ZM13.8594 12.2188H2.14062C1.75294 12.2188 1.4375 11.9033 1.4375 11.5156V6.35938H14.5625V11.5156C14.5625 11.9033 14.2471 12.2188 13.8594 12.2188Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.78125 10.8125H3.3125C3.05363 10.8125 2.84375 10.6026 2.84375 10.3438V9.875C2.84375 9.61613 3.05363 9.40625 3.3125 9.40625H3.78125C4.04012 9.40625 4.25 9.61613 4.25 9.875V10.3438C4.25 10.6026 4.04012 10.8125 3.78125 10.8125Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1476_5205"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15,
    height: 15,
    fill: "white",
    transform: "translate(0.5 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVyshunewcard1);
export default __webpack_public_path__ + "static/media/vyshunewcard1.ea1faf103c8813dac9b24cdaab7b075d.svg";
export { ForwardRef as ReactComponent };